<template>
  <div>
    <iframe
      sandbox="allow-same-origin allow-scripts allow-top-navigation"
      scrolling="no"
      width="300"
      height="400"
      frameBorder="0"
      allowTransparency="true"
      :src="setSrc"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //应用唯一标识，在微信开放平台提交应用审核通过后获得
      appid: "wxeb9afc81e83cbe41",
      //应用授权作用域，拥有多个作用域用逗号（,）分隔，网页应用目前仅填写snsapi_login即可
      scope: "snsapi_login",
      //重定向地址，需要进行UrlEncode
      redirect_uri: "http://longting.singbada.cn/wx/auth",
      //用于保持请求和回调的状态，授权请求后原样带回给第三方。该参数可用于防止csrf攻击（跨站请求伪造攻击），建议第三方带上该参数，可设置为简单的随机数加session进行校验
      href:
        "data:text/css;base64,LmltcG93ZXJCb3ggLnRpdGxlIHsKIGRpc3BsYXk6IG5vbmU7Cn0KLmltcG93ZXJCb3ggLnFyY29kZSB7CiAgICBib3JkZXI6IG5vbmU7CiAgICB3aWR0aDogMjAwcHg7CiAgICBoZWlnaHQ6IDIwMHB4OwogICAgcG9zaXRpb246IGFic29sdXRlOwogICAgdG9wOiAtMjhweDsKICAgIGxlZnQ6IDA7Cn0KLmltcG93ZXJCb3ggLmluZm8gewogICAgd2lkdGg6IDI4MHB4OwogICAgbWFyZ2luOiAwIGF1dG87CiAgICBwb3NpdGlvbjogYWJzb2x1dGU7CiAgICB0b3A6IDIwM3B4OwogICAgbGVmdDogLTYwcHg7Cn0KLmltcG93ZXJCb3ggLnN0YXR1c3sKICAgIHBhZGRpbmc6IDdweCAxNHB4OwogICAgdGV4dC1hbGlnbjogbGVmdDsKICAgIHBhZGRpbmctbGVmdDogNjBweDsKICAgIHdoaXRlLXNwYWNlOiBub3dyYXA7Cn0K",
      // src: 'https://open.weixin.qq.com/connect/qrconnect?appid=wxe1f5def243e0390b&scope=snsapi_login&redirect_uri=https://abstest.tenpay.com/abs/author/callBack.do&state=0001&login_type=jssdk&self_redirect=default&style=black&href=./wx.css',
      // https://open.weixin.qq.com/connect/qrconnect?appid=wxe1f5def243e0390b&scope=undefined&redirect_uri=undefined&state=&login_type=jssdk&self_redirect=default&style=black&href=
    };
  },
  computed: {
    setSrc() {
      var _url =
        "https://open.weixin.qq.com/connect/qrconnect?appid=" +
        this.appid +
        "&scope=" +
        this.scope +
        "&redirect_uri=" +
        this.setRedirect +
        "&state=" +
        this.state +
        "&login_type=" +
        this.login_type +
        "&style=" +
        this.theme +
        "&self_redirect=" +
        this.self_redirect +
        "&href=" +
        this.href;

      console.log(_url);

      return _url;
    },

    setRedirect() {
      var _redirect_uri = encodeURIComponent(
        this.redirect_uri +
          "?" +
          "xbd_appid=" +
          this.xbd_appid +
          "&xbd_redirct_uri=" +
          this.xbd_redirct_uri
      );

      return _redirect_uri;
    },
  },
  props: {
    //方舟对应的项目的appId
    xbd_appid: {
      type: String,
      required: true,
    },
    //验证成功后的跳转地址
    xbd_redirct_uri: {
      type: String,
      required: true,
    },
    //提供"black"、"white"可选，默认为黑色文字描述。详见文档底部FAQ
    theme: {
      type: String,
      default: "black",
    },
    // true：手机点击确认登录后可以在 iframe 内跳转到 redirect_uri，false：手机点击确认登录后可以在 top window 跳转到 redirect_uri。默认为 false。
    self_redirect: {
      type: Boolean,
      default: false,
    },
    // sdk的扩展字符串，但是在这里就默认了jssdk，暂时不建议修改
    login_type: {
      type: String,
      default: "jssdk",
    },
  },
};
</script>
